import Fibernorm from "../../../../src/components/RenderImgs/fibernormImgs";
import * as React from 'react';
export default {
  Fibernorm,
  React
};